import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

interface ICustomBadgeProps {
  backgroundColor?: string;
}

export const CustomBadge = styled("div")(({ backgroundColor }: ICustomBadgeProps) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  backgroundColor: backgroundColor || colors.success50,
  borderRadius: "100px",
  height: "24px",
  maxWidth: "98px",
  padding: "4px 12px",
  width: "fit-content",
  whiteSpace: "nowrap",
}));

interface ITextValue {
  textColor?: string;
}

export const TextValue = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "textColor";
  },
})(({ textColor }: ITextValue) => ({
  color: textColor,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));
